module.exports = __webpack_public_path__ + "img/cloud-sun.61792004.svg";